function isNull(input) {
  return input == null;
}

function isEmpty(input) {
  return (
    (!input && input !== 0) ||
    input.length === 0 ||
    (Object.getPrototypeOf(input) === Object.prototype &&
      Object.getOwnPropertyNames(input).length === 0)
  );
}

function isBlank(input) {
  return isNull(input) || isEmpty(input);
}

/*
isPresent(undefined) === false &&
isPresent(null) === false &&
isPresent("") === false &&
isPresent([]) === false &&
isPresent({}) === false &&
isPresent(0) === true &&
isPresent(1) === true &&
isPresent("Hello") === true &&
isPresent([1, 2, 3]) === true &&
isPresent({ name: "John" }) === true
*/
export function isPresent(input) {
  return !isBlank(input);
}

// Deprecated: use isPresent instead
export function isStringValid(input) {
  return input !== undefined && input !== null && input !== "";
}

// Deprecated: use isPresent instead
export function isObjectValid(input) {
  return input !== undefined && input !== null;
}

export function isArrayEmpty(input) {
  return !Array.isArray(input) || input.length === 0;
}

export function isArrayNotEmpty(input) {
  return Array.isArray(input) && input.length > 0;
}

export const phoneRegex =
  /^(?:(?:\+33|0033)\s*0?[67]\s*(?:\d\s*){8}|0[67](?:\d\s*){8}|(?:\+590|00590|(?:\+596|00596)|(?:\+594|00594)|(?:\+262|00262)|(?:\+41|0041)|(?:\+32|0032))\s*(?:\d\s*){9})$/;
